<template>
  <div class="accordion-item w-100 rounded">
    <label
      forHTML="checkbox-1"
      class="d-flex justify-content-between w-100 align-items-center"
    >
      <p class="lh-1 m-0 fw-medium">
        {{ title ?? item.pageName }}
      </p>
      <input
        type="checkbox"
        class="checkbox-item"
        :checked="selected"
        :value="value"
        @click="$emit('filter', $event.target.checked)"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: "AccordionItem",
  props: {
    title: String,
    value: String,
    item: Object,
    selected: Boolean,
  },
};
</script>

<style scoped>
.accordion-item {
  background-color: #f0f2f8;
  margin-top: 10px;
  padding: 16px 16px;
  display: flex;
}

.checkbox-item {
  height: 1.1rem;
  width: 1.1rem;
  font-size: 1.1rem;
  border-color: #c3cbd9;
}
</style>
